import { ISelectValue } from '~/components/ui/SelectItem';
import { Gender } from '~/shared';

export const selectGenderItems: ISelectValue[] = [
	{
		value: Gender.MALE,
		title: 'Мужской',
	},
	{
		value: Gender.FEMALE,
		title: 'Женский',
	},
];
